<template>
  <div class="centerCenter">
    <div class="container text-center">
      <router-link to="/">
        <img
          class="d-block mx-auto mb-4"
          src="../assets/logo_default.svg"
          alt
          width="100"
          height="100"
        />
      </router-link>

      <h2 class="form-signin-heading py-3">Join TopQuiz now!</h2>

      <form id="signinform" class="form-signin" @submit.prevent="register">
        <!-- USERNAME  -->
        <label for="inputUserName" class="float-left">Username</label>
        <!-- tippy -->
        <TopquizTippy>
          <template slot="trigger">
            <div class="float-right">
              <b-icon-question-circle />
            </div>
          </template>
          <template v-slot:title>Username</template>
          <p>
            You will need this to log in, this is not your quiz team name. This
            is your name. Make it rememberable. Make it unique. Make it
            fabulousPenguin921.
          </p>
          <p class="text-muted">
            Allowed characters include digits, letters and underscores.
          </p>
        </TopquizTippy>
        <!-- input -->
        <b-input
          v-model="username"
          placeholder="Username"
          minlength="3"
          class="mb-2"
          maxlength="30"
          pattern="^[0-9a-zA-ZÀ-ž_]+$"
          required
          autofocus
        />

        <!-- Mail  -->
        <label for="inputUserMail" class="float-left">E-mail</label>
        <!-- tippy -->
        <TopquizTippy>
          <template slot="trigger">
            <div class="float-right">
              <b-icon-question-circle />
            </div>
          </template>
          <template v-slot:title>E-mail</template>
          <p>
            Your mail address is needed to verify your identity for registration
            and when you lose your password. Your mail address will not used for
            anything else or given to a third party.
          </p>
          <p>
            If you do not want to use your own e-mail, check out
            <a href="https://tempail.com/" target="_blank">Tempail</a>. Note:
            You can register with a fake mail, but might not be able to recover
            your password.
          </p>
          <p class="text-muted">Must be a mail address.</p>
        </TopquizTippy>
        <!-- input -->
        <b-input
          v-model="email"
          type="email"
          placeholder="E-mail"
          class="mb-2"
          maxlength="100"
          required
        />

        <!-- Password  -->
        <label for="passWord" class="float-left">Password</label>
        <!-- tippy -->
        <TopquizTippy>
          <template slot="trigger">
            <div class="float-right">
              <b-icon-question-circle />
            </div>
          </template>
          <template v-slot:title>Password</template>
          <p>
            You will need this to log in. Minimum length is 10. Make it strong,
            like a tumeric smoothie.
          </p>
          <p class="text-muted">Minimum length 10.</p>
        </TopquizTippy>
        <!-- input -->
        <b-input
          v-model="password"
          type="password"
          class="mb-4"
          placeholder="Password"
          minlength="10"
          required
        />

        <b-button
          v-bind:disabled="sendingConfirmation"
          variant="primary"
          size="lg"
          block
          type="submit"
          >Register</b-button
        >
      </form>

      <div class="mt-3 text-small">
        Got an account already?
        <router-link to="/login">Sign in here</router-link>
      </div>

      <div class="mt-1 text-small">
        Want a guest account?
        <router-link to="/guest">Click here</router-link>
      </div>

      <slot name="footer"></slot>
    </div>
    <!-- /container -->
    <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
    <DialogInfo
      v-model="infoVisible"
      v-bind:noClose="true"
      title="Confirmation"
      @ok="confirmationCodeSubmitted"
    >
      <span v-if="!usedDirectLink"
        >An email has been sent to you at: {{ email }}</span
      >
      <p>Please enter your confirmation code:</p>
      <form v-if="infoVisible" @submit.prevent="confirmationCodeSubmitted">
        <b-input
          ref="confirmationInput"
          type="text"
          placeholder="ABCXYZ"
          minlength="6"
          maxlength="6"
          v-model="confirmationCode"
          v-bind:class="{ 'is-invalid': confirmationCodeInvalid }"
          autofocus
          required
        />
      </form>

      <template v-slot:leftOfButton>
        <div class="align-self-center flex-grow-1">
          <b-button
            v-bind:disabled="!resendEnabled"
            variant="link"
            @click="resendConfirmationMail"
            >Resend e-mail</b-button
          >
          <b-button variant="outline-success" disabled v-if="sentHintVisible">
            <b-icon-envelope class="mr-2" />e-mail sent!
          </b-button>
        </div>
      </template>
    </DialogInfo>
    <DialogInfo
      v-model="confirmationVisible"
      title="Confirmation success"
      @hidden="goToLogin"
    >
      Your account has been successfully verified! You will be redirected to the
      login page when you close this dialog.
    </DialogInfo>
  </div>
</template>

<script>
import TopquizTippy from "@/components/TopquizTippy";
import DialogInfo from "@/components/DialogInfo";
import DialogError from "@/components/DialogError";

export default {
  name: "Register",
  components: {
    TopquizTippy,
    DialogError,
    DialogInfo
  },
  created() {
    this.$emit("toggle-navbar", false);
    this.$emit("full-body", true);

    try {
      if (this.$route.params.action) {
        this.username = atob(this.$route.params.param);
        this.usedDirectLink = true;
        this.infoVisible = true;

        this.confirmationCode = this.$route.params.param2;
      }
    } catch {
      this.$noop();
    }

    this.$topquiz.on(this, "registration_error", params => {
      this.errorMessage = params[0];
      this.errorVisible = true;

      this.sendingConfirmation = false;
    });

    this.$topquiz.on(this, "registration_success", () => {
      this.infoVisible = true;
      this.sendingConfirmation = false;

      this.sentHintVisible = true;
      setTimeout(() => {
        this.sentHintVisible = false;
      }, 3000);

      this.confirmationResendDisabled = true;
      setTimeout(() => {
        this.confirmationResendDisabled = false;
      }, 10000);
    });

    this.$topquiz.on(this, "confirmation_error", () => {
      this.confirmationCodeInvalid = true;
    });

    this.$topquiz.on(this, "confirmation_success", () => {
      this.infoVisible = false;
      this.confirmationVisible = true;
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  data() {
    return {
      username: "",
      password: "",
      email: "",
      errorMessage: "",
      errorVisible: false,
      infoMessage: false,
      confirmationCode: "",
      confirmationCodeInvalid: false,
      infoVisible: false,
      confirmationVisible: false,
      // true while email is being sent
      sendingConfirmation: false,
      // true while resend should not be used (timer)
      confirmationResendDisabled: false,
      // set to true to inform user of email having been sent
      sentHintVisible: false,
      // set to true, when user used confirmation link
      usedDirectLink: false
    };
  },
  computed: {
    resendEnabled() {
      return !this.sendingConfirmation && !this.confirmationResendDisabled;
    }
  },
  methods: {
    register() {
      this.$topquiz.sendCommand(
        "registration",
        this.username,
        this.email,
        "<hidden>" + this.password
      );

      this.sendingConfirmation = true;
    },
    confirmationCodeSubmitted(ev) {
      ev.preventDefault();

      if (!this.confirmationCode) {
        this.errorMessage = "Please enter a confirmation code...";
        this.errorVisible = true;
      }

      if (this.confirmationCode.length < 6) {
        this.errorMessage =
          "This confirmation code is too short. It should be 6 characters long.";
        this.errorVisible = true;
      }

      if (this.confirmationCode.length == 6) {
        this.$topquiz.sendCommand(
          "confirmation",
          this.username,
          this.confirmationCode
        );
      }
    },
    goToLogin() {
      this.$router.replace("/login");
    },
    resendConfirmationMail() {
      this.sendingConfirmation = true;
      this.$topquiz.sendCommand("resendConfirmation", this.username);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 500px;
}
</style>
